// 收费类型
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("costType") || ""
}

const getters = {
  getCostType:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("costType",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("costType")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}